import MessageApi from '../../../../api/inbox/message';

export default {
  async editMessage({ commit }, { conversationId, messageId, content }) {
    const { data } = await MessageApi.editMessage(
      conversationId,
      messageId,
      content
    );
    // Server returns updated message; merge it into store
    commit('ADD_MESSAGE', data);
  },
};
